import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Button, ButtonGroup, makeStyles } from "@material-ui/core";
import AssignmentIcon from '@material-ui/icons/Assignment';
import { TooltipBottom } from "./CustomTooltips";
import CSVReader from "react-csv-reader";
import t from "../../languages/pl";
import AdditionalInformationDialog from "../Common/AdditionalInformationDialog";

const useStyles = makeStyles({
    csvReader: {
        display: "none"
    },
    buttonGroup: {
        marginRight: 8
    }
});

const UploadFileOrTemplate = props => {
    const { onFileLoaded, template, tooltipText, informationDialog } = props;
    const classes = useStyles();
    const [uploadKey, setUploadKey] = useState(Math.random().toString(36));
    const [showDialog, setShowDialog] = useState(false);

    const handleClick = () => {
        if(informationDialog) {
            setShowDialog(true);
        } else {
            document.getElementById("csvReader").click();
        }
    };

    const handleFileLoaded = data => {
        onFileLoaded && onFileLoaded(data);
        setUploadKey(`${Math.floor(Math.random()*36)}`);
    };

    return (
        <React.Fragment>
            <ButtonGroup
                variant="contained"
                color="secondary"
                className={classes.buttonGroup}
            >
                <TooltipBottom title={t.importTemplate}>
                    <Button
                        color="secondary"
                        component={Link}
                        to={template}
                        download={t.template}
                        target="_blank"
                        name="csv"
                    >
                        <AssignmentIcon />
                    </Button>
                </TooltipBottom>
                <CSVReader
                    key={uploadKey}
                    inputId="csvReader"
                    cssClass={classes.csvReader}
                    accept=".csv"
                    onFileLoaded={handleFileLoaded}
                    parserOptions={{
                        header: true,
                        skipEmptyLines: true
                    }}
                />
                <TooltipBottom
                    title={tooltipText}
                >
                    <Button
                        onClick={handleClick}
                    >
                        {t.importFromFile}
                    </Button>
                </TooltipBottom>
            </ButtonGroup>
            <AdditionalInformationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onSubmit={() => document.getElementById("csvReader").click()}
                action={t.utf8FileInformation}
            />
        </React.Fragment>
    );
};

UploadFileOrTemplate.propTypes = {
    template: PropTypes.node,
    tooltipText: PropTypes.string,
    onFileLoaded: PropTypes.func,
    informationDialog: PropTypes.bool,
};

export default UploadFileOrTemplate;
